import React  from "react";
import { Layout, Menu, Icon, Button } from "antd";
import { Link } from "react-router-dom";
import "./Sider2.scss";

export default function Home(props) {
  const { SubMenu } = Menu;
  const { Sider } = Layout;
  const { menu, menuSelect, setMenuSelect } = props;
  
  const handleOnClick = (datos) => {
    const menuSelect = [datos.key];
    setMenuSelect(menuSelect);
  };
  
  return (
    <Sider collapsible style={{ background: "#f2f2f2" }} width={230}>
      <Menu
        defaultSelectedKeys={["1"]}
        mode="inline"
        onClick={handleOnClick}
        selectedKeys={menuSelect}
        //style={{ marginTop: "50px" }}
      >
        {/* <Button icon="home" href="/admin/home">
          Inicio
        </Button> */}

        {/* <Menu.Item key="inicio">
          <Link to={"/admin/home"} />
          <Icon type="home" />
          Inicio
        </Menu.Item> */}

        {menu.map((itemMenu) => (
          <SubMenu key={itemMenu.nombreMenu} title={itemMenu.nombreMenu}>
            {itemMenu.subMenus[0].modulos.map((opt) => (
              <Menu.Item key={opt.urlModulo}>
                <Link
                  to={{
                    pathname: opt.urlModulo,
                    state: {
                      actionList: opt.listAccionesModulo,
                    },
                  }}
                />
                {opt.nombreModulo}
              </Menu.Item>
            ))}
          </SubMenu>
        ))}
      </Menu>
      <div style={{ textAlign: "center", marginTop: "30px" }}>
        <Link to={"/admin/reportes"}>
          <Button className="btn_reportes" onClick={()=>setMenuSelect([])}>
            <Icon type="bar-chart" />
            Reportes
          </Button>
        </Link>
      </div>
    </Sider>
  );
}
